import { Component, computed, inject, input } from '@angular/core';
import { MatMiniFabButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { WidgetDataStore } from '../../../../stores/widget-data.store';
import { CountListWidget, CountListWidgetData } from '../../models';

@Component({
  imports: [MatMiniFabButton, MatTooltip],
  selector: 'siat-count-list-widget',
  templateUrl: './count-list-widget.component.html',
})
export class CountListWidgetComponent {
  /**
   * The widget data store.
   */
  private widgetDataStore = inject(WidgetDataStore);

  /**
   * The router.
   */
  private router = inject(Router);

  /**
   * The widget.
   */
  widget = input.required<CountListWidget>();

  /**
   * The widget data.
   */
  widgetData = computed<CountListWidgetData[]>(() => {
    const data = this.widgetDataStore.getWidgetData<CountListWidgetData[]>(
      this.widget()?.id
    );
    return data || [];
  });

  keyParams = computed(() => this.widget().config.path?.keyParams);

  /**
   * On click on count item
   */
  onCountClick(item: CountListWidgetData) {
    const viewAll = this.widget().config?.path?.viewAll;
    const key = this.keyParams();
    if (!viewAll || !key) return;

    const filterKey = key.toLowerCase().includes('tag') ? 'nomeTag' : key;
    const queryParams = { [filterKey]: item[key] ?? '' };
    if (viewAll.includes('prestazioni')) {
      queryParams['stati'] = 'NON_ASSEGNATA,ASSEGNATA';
    } else {
      queryParams['stati'] = 'NON_IN_GESTIONE,IN_GESTIONE';
    }

    this.router.navigate([`/home/${viewAll}`], {
      queryParams,
    });
  }
}
